import React from 'react'
import createPlanMutation from 'graphs/mutations/createPlan.graphql'
import planValidation from 'validations/plan'
import LedgerClient from 'components/LedgerClient'
import FormForRecord from 'components/FormForRecord'
import planFields from 'fields/plans'

const RouteCompaniesUsersNew = ({ history: { goBack }, company, ...rest }) => (
  <LedgerClient>
    {({ mutate }) => (
      <FormForRecord
        onSuccess={goBack}
        onCancel={goBack}
        fields={planFields}
        schema={planValidation}
        title={`Create a Plan for ${company.name}`}
        mutate={({ variables }) =>
          mutate({
            mutation: createPlanMutation,
            variables: { companyId: company.id, ...variables.data }
          })
        }
        {...rest}
      />
    )}
  </LedgerClient>
)

export default RouteCompaniesUsersNew



// WEBPACK FOOTER //
// ./src/routes/admin/companies/plans/new.js